import type { StatusLifecycleDisplay } from "@/services/lifecycle/lifecycle.types";

function normalizeSource(row: StatusLifecycleDisplay): string {
	return (row.source ?? "").trim().toLowerCase();
}

/** Platform admin: system lifecycles only (treat missing source as system). */
export function filterPlatformLifecycleRows(
	rows: StatusLifecycleDisplay[],
): StatusLifecycleDisplay[] {
	return rows.filter((row) => {
		const s = normalizeSource(row);
		return s === "" || s === "system";
	});
}

/**
 * Org admin: system lifecycles (global) plus custom lifecycles owned by the organization.
 */
export function filterOrgAdminLifecycleRows(
	rows: StatusLifecycleDisplay[],
	organizationId: string,
): StatusLifecycleDisplay[] {
	return rows.filter((row) => {
		const s = normalizeSource(row);
		if (s === "" || s === "system") return true;
		if (s === "custom") {
			const oid = row.organizationId ?? "";
			return oid === organizationId;
		}
		return row.organizationId === organizationId;
	});
}

export function isLifecycleActive(row: StatusLifecycleDisplay): boolean {
	if (typeof row.isActive === "boolean") return row.isActive;
	if (typeof row.active === "boolean") return row.active;
	return true;
}
